<template>
  <div id="misc">
    <!-- <img
      class="misc-mask"
      height="226"
      :src="require(`@/assets/images/misc/misc-mask-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
    /> -->

    <!-- <v-img
      class="misc-tree"
      src="@/assets/images/misc/tree-4.png"
    ></v-img> -->

    <div class="page-title text-center px-4">
      <h2 class="text-2xl font-weight-semibold text--primary d-flex align-center justify-center">
        <span class="me-2">Pagina não encontrada</span>
        <v-icon color="warning">
          {{ icons.mdiAlert }}
        </v-icon>
      </h2>
      <p class="text-sm">
        não encontramos a página que você procura
      </p>

      <div class="misc-character d-flex justify-center">
        <v-img
          max-width="900"
          :src="require(`@/assets/images/logos/TECH_Horizontal_${$vuetify.theme.dark ? 'White' : 'Color'}.png`)"
        ></v-img>
      </div>

      <v-btn
        color="primary"
        to="/"
        class="mt-15"
      >
        Voltar ao início
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mdiAlert } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiAlert,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/misc.scss';
</style>
